import { useEffect, useState } from 'react';
import {
    asyncGetPqr,
    asyncGetPqrHistorical,
} from '../../../../../services/pqr.service';
import { useNavigate, useParams } from 'react-router-dom';
import { Pqr, PqrHistorical } from '../../../../../shared/types/modules/pqr';
import { ACCOUNTS, PQR } from '../../../../../routes/paths';

export const usePqrDetail = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idPqr } = useParams();
    const [loading, setLoading] = useState(false);
    const [pqr, setPqr] = useState<Pqr>();

    const [pqrHistorical, setPqrHistorical] = useState<PqrHistorical[]>();

    useEffect(() => {
        if (Boolean(idPqr?.trim())) {
            setLoading(true);
            asyncGetPqr(idPqr?.trim())
                .then((pqr) => {
                    if (pqr) setPqr(pqr);
                    else navigate(ACCOUNTS);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqr]);

    useEffect(() => {
        if (Boolean(idPqr?.trim()) && showHistorical) {
            setLoading(true);
            asyncGetPqrHistorical(idPqr?.trim())
                .then((resp) => {
                    if (resp) setPqrHistorical(resp);
                    else navigate(PQR);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqr, showHistorical]);

    return { loading, pqr, pqrHistorical };
};
